module.exports = __webpack_public_path__ + "static/media/logo.7b7077e8.png";